import React, { useState } from "react";
import "./Who_We_Are.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import InquiryFormModal from "../../common_components/InquiryFormModal/InquiryFormModal";

const Who_We_Are = () => {
  const [modalshow, setmodalshow] = useState(false);

  return (
    <section className="Who_we_are_sec">
      <div className="container">
        <div className="who-we-are-inner">
          <div className="who-we-are-main">
            <div className="who-we-are-image-col">
              <div className="img-sec">
                <img
                  className="studentimg"
                  src="/assets/images/home/who-we-are/dypatil.png"
                  alt="Dr. D.Y. Patil University"
                />
              </div>
            </div>

            <div className="who-we-are-content-col">
              <div className="content-sec">
                <div className="text-left">
                  <h3 className="commontitle">B.A. Degree Programme</h3>

                  <p className="commonsubtitle">
                    India’s Leading Online Deemed-to-be University
                  </p>
                </div>

                <p className="abt_dpu">
              The Online Bachelor of Arts (B.A.) programme at Dr. D.Y. Patil Vidyapeeth - Centre for Online Learning is designed to provide broad-based knowledge in social sciences and humanities through a flexible online learning model.

The programme develops learners' understanding of society, politics, culture, development, governance, media and contemporary social issues, while strengthening critical thinking, communication, research aptitude, digital literacy and leadership skills.

Designed for learners from diverse backgrounds, the programme can support HSC (10+2) students, working professionals, self-employed individuals, homemakers, social-sector workers and competitive examination aspirants seeking higher education and career growth.

The curriculum combines foundational and interdisciplinary subjects with areas such as political systems, psychology, sociology, economics, philosophy, geography, development studies, social research, public policy, international relations, governance and social entrepreneurship.

Through online learning resources, recorded lectures, interactive sessions, digital study materials, assignments, assessments and academic support, learners can pursue their degree while managing their personal, academic or professional commitments.
                </p>
{/* 
                <div className="university-features">
                  <div className="university-feature-item">
                    <div className="flexuni">
                      <div className="icondiv">
                        <img
                          className="icon"
                          src="/assets/images/home/who-we-are/university.png"
                          alt=""
                        />
                      </div>

                      <div className="textdiv">
                        <p>University Mission Statement</p>
                      </div>
                    </div>
                  </div>

                  <div className="university-feature-item">
                    <div className="flexuni">
                      <div className="icondiv">
                        <img
                          className="icon"
                          src="/assets/images/home/who-we-are/school.png"
                          alt=""
                        />
                      </div>

                      <div className="textdiv">
                        <p>University Vision Achievement</p>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>

          <div className="ranked_div">
            <div className="ranked-item bd-right">
              <h1>Ranked #1</h1>
              <p>Among Online &amp; Distance Learning Institutes</p>
            </div>

            <div className="ranked-item">
              <h1>40 Years</h1>
              <p>of Consistent Excellence</p>
            </div>
          </div>

          <div className="btn_holder">
            <button
              className="Red_Btn"
              type="button"
              onClick={() => setmodalshow(true)}
            >
              <p className="btn_text">Enquire Now</p>

              <div className="icon_holder">
                <FontAwesomeIcon icon={faArrowRight} className="icon" />
              </div>
            </button>
          </div>
        </div>
      </div>

      <InquiryFormModal
        show={modalshow}
        onHide={() => setmodalshow(false)}
        setmodalshow={setmodalshow}
        modalshow={modalshow}
      />
    </section>
  );
};

export default Who_We_Are;
